import { render, staticRenderFns } from "./Reflections.vue?vue&type=template&id=7a612905&scoped=true&"
import script from "./Reflections.vue?vue&type=script&lang=js&"
export * from "./Reflections.vue?vue&type=script&lang=js&"
import style0 from "./Reflections.vue?vue&type=style&index=0&id=7a612905&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a612905",
  null
  
)

export default component.exports